import apiFetch from '../apiFetch'

export default function () {
  return apiFetch({endPoint: `auth/getInformacionLicencia`, method: 'GET'})
}
